import { render, staticRenderFns } from "./UploadAttachment.vue?vue&type=template&id=32a32202&"
import script from "./UploadAttachment.vue?vue&type=script&lang=js&"
export * from "./UploadAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports